import React from 'react';

import FieldMultiPhone from '../common/FieldMultiPhone';
import FieldMultiValue from '../common/FieldMultiValue';
import FieldAddress from '../common/FieldAddress';

class ContactAddEditContact extends React.Component {

  render() {
    const fields = this.props.model.fields;
    const contact = this.props.contact;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;

    return (
      <>
        <div className="formhead col-md-12"><h2>Contact Information</h2></div>

        <FieldMultiPhone key="phone" id="phone" field={fields.phone}
          value={contact.phone} onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiValue key="email" id="email" field={fields.email} value={contact.email}
          onValueChange={onValueChange} inValid={inValid} />

        <FieldAddress key="address" id="address" field={fields.address} value={contact.address}
          onValueChange={onValueChange} inValid={inValid} />
      </>
    );
  }
}

export default ContactAddEditContact;